import React from 'react'
import _ from 'lodash'
import { functionalitiesHelper } from '../../../../../utils/functionalitiesHelper'
import { STATUSES } from '../constants'
import { ReactComponent as CancelledIcon } from '../../../../../assets/icons/schedulingStatus/cancelled.svg'
import { ReactComponent as NoShowIcon } from '../../../../../assets/icons/schedulingStatus/no_show.svg'
import { ReactComponent as InProgressIcon } from '../../../../../assets/icons/schedulingStatus/in_progress.svg'
import { ReactComponent as FinishedIcon } from '../../../../../assets/icons/schedulingStatus/finished.svg'
import { ReactComponent as ScheduledIcon } from '../../../../../assets/icons/schedulingStatus/scheduled.svg'

const { sortObjArrayByValue } = functionalitiesHelper

const STANDARD_TEXT_INFO = { professional: { singular: 'vinculado ao', plural: 'vinculados ao' }, freelancer: { singular: 'vinculado aos', plural: 'vinculados aos' } }

const STATUS_INFO = [
  {
    name: 'no_show',
    label: STATUSES.no_show,
    icon: <NoShowIcon />,
    desc: { singular: 'em que o cliente não veio', plural: 'em que o cliente não veio' },
    textInfo: STANDARD_TEXT_INFO
  },
  {
    name: 'cancelled',
    label: STATUSES.cancelled,
    icon: <CancelledIcon />,
    desc: { singular: 'cancelado', plural: 'cancelados' },
    textInfo: STANDARD_TEXT_INFO
  },
  {
    name: 'scheduled',
    label: STATUSES.scheduled,
    icon: <ScheduledIcon />,
    desc: { singular: 'não iniciado', plural: 'não iniciados' },
    textInfo: STANDARD_TEXT_INFO
  },
  {
    name: 'in_progress',
    label: STATUSES.in_progress,
    icon: <InProgressIcon/>,
    desc: { singular: 'em andamento', plural: 'em andamento' },
    textInfo: STANDARD_TEXT_INFO
  },
  {
    name: 'finished',
    label: STATUSES.finished,
    icon: <FinishedIcon />,
    desc: { singular: 'finalizado', plural: 'finalizados' },
    textInfo: { professional: { singular: 'realizado pelo', plural: 'realizados pelo' }, freelancer: { singular: 'realizado pelos', plural: 'realizados pelos' } }
  }
]

export const organizeDataByDetailedStatus = (data) => sortObjArrayByValue(_.map(STATUS_INFO, (status) => {
  const total = (data.professional?.attendancesByStatus[status.name] ?? 0) + (data.freelancers?.attendancesByStatus[status.name] ?? 0)
  const professionalSchedulings = data.professional?.schedulingsByStatus[status.name] || 0
  const freelancerSchedulings = data.freelancers?.schedulingsByStatus[status.name] || 0
  const professionalOverbooks = data.professional?.overbooksByStatus[status.name] || 0
  const freelancerOverbooks = data.freelancers?.overbooksByStatus[status.name] || 0

  return {
    label: status.label,
    icon: status.icon,
    desc: total === 1 ? status.desc.singular : status.desc.plural,
    schedulings: {
      professional: {
        total: professionalSchedulings,
        textInfo: status.textInfo.professional[professionalSchedulings === 1 ? 'singular' : 'plural']
      },
      freelancer: {
        total: freelancerSchedulings,
        textInfo: status.textInfo.freelancer[freelancerSchedulings === 1 ? 'singular' : 'plural']
      }
    },
    overbooks: {
      professional: {
        total: professionalOverbooks,
        textInfo: status.textInfo.professional[professionalOverbooks === 1 ? 'singular' : 'plural']
      },
      freelancer: {
        total: freelancerOverbooks,
        textInfo: status.textInfo.freelancer[freelancerOverbooks === 1 ? 'singular' : 'plural']
      }
    },
    total
  }
}).filter(status => status.total > 0), 'total', 'label')
